import "dayjs/locale/de";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/id";
import "dayjs/locale/it";
import "dayjs/locale/ja";
import "dayjs/locale/nl";
import "dayjs/locale/pl";
import "dayjs/locale/pt";
import "dayjs/locale/ru";
import { StringMap, TFunction, TOptions, i18n } from "i18next";
import { CrossSellTranslations } from "../../helpers/getCrossSellProductsConfig.js";
import { ProspectStatusTranslations } from "../../helpers/getLinkedInStatusText.js";

export enum Languages {
    FR = "fr",
    EN = "en",
    ES = "es",
    RU = "ru",
    DE = "de",
    ID = "id",
    IT = "it",
    NL = "nl",
    PL = "pl",
    PT = "pt",
}

export const isLanguage = (lang: string): lang is Languages => Object.values(Languages).includes(lang as Languages);

export type CustomTFunction = (key: Parameters<TFunction>[0], options?: TOptions<StringMap> | string) => string;

export type TranslationValue = {
    [key: string]: string | (() => string) | TranslationValue;
};

export type BaseTranslationDictionary = TranslationValue & ProspectStatusTranslations & CrossSellTranslations;

export type AugmentedI18n<TranslationDictionary extends BaseTranslationDictionary> = i18n & {
    translationsData: Record<string, TranslationDictionary>;
};
